var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:['my-option', { selected: _vm.selected }],on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[(!_vm.$slots.default)?_c('span',[_vm._v(_vm._s(_vm.myLabel))]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"fa fa-check pull-right"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-915f4698","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown/myOption.vue
// module id = 162
// module chunks = 0